const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function isBattleId(value) {
    return UUID_RE.test(value.trim());
}
export function buildBattleWebAppUrl(webAppUrl, battleId) {
    const base = webAppUrl.replace(/\/$/, '');
    return `${base}/?battle=${encodeURIComponent(battleId)}`;
}
/** Telegram invite link shared to contacts. */
export function buildTelegramInviteLink(options) {
    const { botUsername, battleId, miniAppShortName } = options;
    const bot = botUsername.replace(/^@/, '');
    if (miniAppShortName?.trim()) {
        const param = encodeURIComponent(battleId);
        const app = miniAppShortName.trim();
        return `https://t.me/${bot}/${app}?startapp=${param}&startApp=${param}`;
    }
    // Reliable on Telegram Web/Desktop/Mobile: open bot → webApp button with ?battle=
    return `https://t.me/${bot}?start=join_${battleId}`;
}
export function parseBattleIdFromStartPayload(payload) {
    if (!payload?.trim())
        return null;
    const value = payload.trim();
    if (value.startsWith('join_')) {
        const battleId = value.slice(5);
        return isBattleId(battleId) ? battleId : null;
    }
    return isBattleId(value) ? value : null;
}
//# sourceMappingURL=inviteLinks.js.map